import { VerticalLayout } from "../components/layout"

export const ThemeSideNav = ({activeNav,navItems,handleNavClick}) => {
    return(
        <VerticalLayout className="theme-side-nav">
        {
            navItems.map((item,index) => {
                return(
                    <SidenavItem
                        key={index}
                        title={item.title}
                        active={activeNav == item.navID}
                        onClick={() => handleNavClick(item.navID)}
                    />
                )
            })
        }
        </VerticalLayout>
    )

}

const SidenavItem = ({title,active,onClick}) => {
    return(
        <div onClick={onClick} className={`sidenav-item phone-no-margin-left ${active && "active"}`}>
            <p className={`small-text ${active && "bold-text"}`}>{title}</p>
        </div>
    )
}